import { Component, OnInit, OnDestroy } from '@angular/core';
import { News } from '@app/models/news';
import { NewsService } from '@app/services/news/news.service';
import { NavcontrolService } from '@app/services/navcontrol.service';
import { Subscription } from 'rxjs';
import { ClaimsService } from '@app/services/claims/claims.service';
import { EditorService } from '@app/services/editor/editor.service';
import { AuthService } from '@app/services/auth/auth.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { AdminService } from '@app/services/admin/admin.service';
import { MemberService } from '@app/services/member.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.css']
})

export class StartComponent implements OnInit, OnDestroy {
  newsSubscription: Subscription;
  ownBaseInfoSubscription: Subscription;
  members: any[] = [];
  news: News[] = [];
  baseinfo: string;
  editorContent;
  showeditor = false;
  isClerk = false;
  isSysAdmin = false;
  accesstoken;
  role;
  navbaraccess;
  mobiledevice = false;
  text;
  textmobile;

  constructor(
    private newsservice: NewsService,
    private adminService: AdminService,
    private permissionsService: PermissionsService,
    private navcontrolService: NavcontrolService,
    private claimsService: ClaimsService,
    private editorService: EditorService,
    private authService: AuthService,
  private sanitizer: DomSanitizer) { }

  async ngOnInit() {
     
    this.authService.isMobileDevice.subscribe(mobile => {
      this.mobiledevice = mobile;
    });

    await this.permissionsService.selectedrole.subscribe(r => {
      this.role = r;
    });

    this.newsSubscription = this.newsservice.getNews().subscribe(data => {
      this.news = data;
    });

    this.ownBaseInfoSubscription = this.claimsService.claims$.subscribe(data => {
      if(data) {
      this.baseinfo = data;
      this.isClerk = this.claimsService.isClerk();
      this.isSysAdmin = this.claimsService.isSysAdmin();
      }
    });

    
    this.authService.accesstoken.subscribe(a => { 
      this.accesstoken = a; 
    if(this.accesstoken) {
    
    this.text = this.getFirstPageText(false);
    this.editorService.getEditorContent('startpage_editor1').subscribe(response => {
      if (response) {
        this.editorContent = response;
      }
    });

  }
    });
      }

  getFirstPageText(isMobile) {
    this.adminService.getFirstPageText(isMobile).subscribe(text => {
      const displayHTML = this.getDisplayText(text.text);
      this.text = this.sanitizer.bypassSecurityTrustHtml(displayHTML) as string;
      this.getMobileText();
    });
  }

  getMobileText() {
    this.adminService.getFirstPageText(true).subscribe(text => {
      this.textmobile = this.getDisplayText(text.text);
    });
  }

  private getDisplayText(rawText: string): string {
    return (rawText || '')
      .replace(/<\/p>\s*<p><br><\/p>\s*<p>/gi, '<br><br>')
      .replace(/<\/p>\s*<p>/gi, '<br>')
      .replace(/<p>/gi, '')
      .replace(/<\/p>/gi, '');
  }

  ngOnDestroy() {
    this.newsSubscription.unsubscribe();
    this.ownBaseInfoSubscription.unsubscribe();
  }

  updateNavControl(prop, val) {
    this.navcontrolService.updateNavControlVal(prop, val);
  }

  saveContent() {
    const editordata = {
      editorId: 'startpage_editor1',
      content: this.editorContent
    };
    this.editorService.updateEditorContent(editordata).subscribe(response => {
      this.showeditor = false;
    });
  }

  cancelEditor() {
    this.showeditor = false;
  }

}
